module.exports = require("@tiptap/starter-kit");